import { autorun } from 'mobx';

import GoogleAnalytics4EventHandler from '../GoogleAnalytics4/GoogleAnalytics4EventHandler';

const dimension1 = {
  VISITOR: 'Vierailija-asiakas',
  LOGGED_IN_USER: 'Kirjautunut asiakas',
};

const dimension2 = {
  RETAILER: 'Tukkuasiakas',
  CONSUMER: 'Kuluttaja-asiakas',
};

export default class GoogleAnalyticsGTM {
  /**
   * Private Fields
   */
  #rootStore;

  constructor(rootStore) {
    const { accountStore } = rootStore;
    this.#rootStore = rootStore;

    this.#initializeDataLayer();

    autorun(() => {
      const initialDataLayer = {
        loggedInStatus: accountStore.loggedIn
          ? dimension1.LOGGED_IN_USER
          : dimension1.VISITOR,
        customerType: accountStore.isRetailer
          ? dimension2.RETAILER
          : dimension2.CONSUMER,
        customerGroup: accountStore.account?.group_name || null,
      };

      window.dataLayer.push(initialDataLayer);
    });
  }
  setup = () => {
    this.#addGoogleAnalytics4EventListener();
  };

  #initializeDataLayer = () => {
    if (!window.dataLayer) {
      window.dataLayer = [];
    }
  };

  #addGoogleAnalytics4EventListener = () => {
    const analyticsEventHandler = new GoogleAnalytics4EventHandler(
      this.#rootStore
    );
    this.#addEventListener(analyticsEventHandler);
  };

  /**
   *
   * @param {GoogleAnalytics4EventHandler} analyticsEventHandler
   */
  #addEventListener = (analyticsEventHandler) => {
    document.addEventListener(
      'analytics',
      analyticsEventHandler.handleAnalyticsEvents,
      true
    );
  };
}
